import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeHeaderComponent } from "./home-header/home-header.component";
import { MaterialModule } from "../material.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MultipleErrorMessageComponent } from "./multiple-error-message/multiple-error-message.component";
import { ErrorMessageComponent } from "./error-message/error-message.component";
import { TextAreaComponent } from "./text-area/text-area.component";
import { IdentificationDirective } from "./directives/identification.directive";
import { AddSymbolDirective } from "./directives/add-symbol.directive";
import { AvatarComponent } from "./avatar/avatar.component";

@NgModule({
  declarations: [
    HomeHeaderComponent,
    MultipleErrorMessageComponent,
    ErrorMessageComponent,
    TextAreaComponent,
    IdentificationDirective,
    AddSymbolDirective,
    TextAreaComponent,
    AvatarComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    HomeHeaderComponent,
    TextAreaComponent,
    IdentificationDirective,
    AddSymbolDirective,
    AvatarComponent,
  ],
})
export class SharedModule {}
